import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import stores from 'cd-eft/models/Stores';
import { removeSingleLayerFromMap } from '../SurveySummary/SurveySummaryVM';
import { appConfig } from 'cd-eft/config/AppConfig';
import { DesignElementController, SetSurveyController } from 'cd-eft/services/eftSetApi';

const designStore = stores.AppStore.designStore;
const setStore = stores.AppStore.surveyEngineeringStore;

// cancel edit / discard survey
export const cancelEditXYZSurvey = () => {
  // remove layer if new survey editing cancel
  if (!setStore.currentSurvey.surveyId) removeSingleLayerFromMap('new_survey');
  setStore.resetXYZSurvey();
};

//save TIN surface
export const saveTinSurface = async () => {
  const postJSON = {
    surfaceDefId: designStore.currentSurface.surfaceDefId,
    sessionId: designStore.projectsStore.currentSessionId,
    designElementTypeId: appConfig.hardCodes.designElementTypeSuface,
    designElementName: 'surface',
    contourInterval:designStore.contourInterval
  };
  MessageCenter.clearMessages();
  try {
    // console.log('addDesignElement payload:', postJSON);
    const response: any = await DesignElementController.addDesignElementUsingPOST(postJSON)
    // console.log('addDesignElement response:', response.data);
    // update the design store
    designStore.currentSurface.designElementId = response.data.designElementId;
    designStore.currentSurface.borderVector = JSON.parse(response.data.json).borderVector;
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
};

//save button onClick functionality
export const saveXYZSurvey = async () => {
  //to remove blank or invalid rows that were added to Survey Points table
  setStore.xyzPointsTable = setStore.xyzPointsTable.filter(
    (e) => !(e.pointName === false || e.x === 0 || e.y === 0 || e.z === 0),
    1
  );

  //Rounding x,y,z coordinates of a point to six decimal digits 
  setStore.xyzPointsTable.forEach((e) => { for (const key of Object.keys(e)) { e[key] = isNaN(e[key]) ? e[key] : Math.round(e[key] * 1000000) / 1000000 } })

  //upload new survey
  if (setStore.isImportingNewSurvey) setStore.currentSurvey.surveyId = '';
  if (!setStore.currentSurvey.surveyId) {
    const surveyTableJson = {
      surfaceDefId: designStore.currentSurface.surfaceDefId,
      sessionId: designStore.projectsStore.currentSessionId,
      surveyTypeId: appConfig.hardCodes.surveyTypeXYZ,
      surveyName: setStore.currentSurvey.surveyName,
      surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
      xyzArray: setStore.xyzPointsTable,
    };
    return await saveNewXYZSurvey(surveyTableJson);
  }
  //save edits to existingXYZSurvey are handled via pending edit manager using /editSurface api
  //editing existing survey
  /*   else {
      //editSurvey payload considers all survey points EXCEPT the points with editing_status 'original' and points with editing_status 'add' & has id
      const editSurveyPoints: any[] = setStore.xyzPointsTable.filter(
        (surveyPoint) =>
          surveyPoint.editing_status !== 'original' && !(surveyPoint.editing_status === 'add' && surveyPoint.id)
      );
      const editSurveyJson = {
        surfaceDefId: designStore.currentSurface.surfaceDefId,
        sessionId: designStore.projectsStore.currentSessionId,
        surveyId: setStore.currentSurvey.surveyId,
        surveyTypeId: appConfig.hardCodes.surveyTypeXYZ,
        surveyName: setStore.currentSurvey.surveyName,
        surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
        xyzArray: editSurveyPoints,
      };
      await saveExistingXYZSurvey(editSurveyJson);
    } */
};

/* //save edits to existingXYZSurvey are handled via pending edit manager using /editSurface api
 export const saveExistingXYZSurvey = async (editSurveyJson) => {
  try {
    //const response = await axios.post(baseURL + setEndpoints.editSurvey, editSurveyJson);
    const response = await SetSurveyController.editSurveyUsingPOST(editSurveyJson);
    // console.log('response.data:', response.data);
    setStore.editPointsObject.surveyId = response.data.surveyId;
    setStore.editBreaklinesObject.surveyId = response.data.surveyId;
    setStore.addSketch.surveyId = response.data.surveyId;
    setStore.currentSurvey.surveyId = response.data.surveyId;
    MessageCenter.clearMessages();
    // save Tin surface
    if (setStore.saveTINSurface) {
      await saveTinSurface();
    }
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
}; */

export const saveNewXYZSurvey = async (surveyTableJson) => {
  MessageCenter.clearMessages();
  try {
    // calling loadSurvey api to insert survey in db
    // Jared: Added interval number of 2 as placeholder - This needs to be changed for actual use
    const response = await SetSurveyController.loadSurveyNewUsingPOST(designStore.contourInterval,surveyTableJson)
    // save Tin surface
    await saveTinSurface();
    return response;
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
};
